import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.048 14.459L1.064 14.491C2.709 17.759 6.091 20 10 20C12.7 20 14.964 19.105 16.618 17.577L16.64 17.557C18.518 15.816 19.6 13.261 19.6 10.227C19.6 9.518 19.536 8.836 19.418 8.182H10V12.05H15.382C15.152 13.29 14.456 14.343 13.411 15.051L13.386 15.068C12.491 15.668 11.345 16.023 10 16.023C7.406 16.023 5.208 14.277 4.414 11.928L4.405 11.9C4.205 11.3 4.091 10.659 4.091 10C4.091 9.341 4.205 8.7 4.405 8.1L4.414 8.072C5.208 5.723 7.406 3.977 10 3.977C11.468 3.977 12.786 4.482 13.823 5.473L16.691 2.605C14.959 0.991 12.695 0 10 0C6.106 0 2.735 2.223 1.083 5.471L1.064 5.509C0.386 6.859 0 8.386 0 10C0 11.601 0.38 13.117 1.048 14.459Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}